import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IntegrationDao } from '../../../core/services/dao/integrationDao';
import { ApiHelper } from '../../../core/services/apiHelper';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html'
})
export class RedirectComponent implements OnInit, OnDestroy {
  state = 'connecting';

  constructor(public route: ActivatedRoute, private integrationDao: IntegrationDao, public apiHelper: ApiHelper) {
    switch (route.snapshot.params.platform) {
      case 'snapchat':
        // this.integrationDao
        //   .generateSnapchatTokens(route.snapshot.queryParams.state, route.snapshot.queryParams.code)
        //   .subscribe(res => {
        //     this.notifyOpener('snapchat', res.id);
        //   });
        break;
      case 'amazon':
        // this.integrationDao
        //   .generateAmazonTokens(route.snapshot.queryParams.state, route.snapshot.queryParams.code)
        //   .subscribe(res => {
        //     this.notifyOpener('amazon', res.id);
        //   });
        break;
      case 'twitter':
        // this.integrationDao
        //   .generateTwitterAccessToken(
        //     route.snapshot.queryParams.state,
        //     route.snapshot.queryParams.oauth_token,
        //     route.snapshot.queryParams.oauth_verifier
        //   )
        //   .subscribe(res => {
        //     this.notifyOpener('twitter', res.id);
        //   });
        break;
      case 'google_analytics':
        let state = JSON.parse(route.snapshot.queryParams.state);
        // this.integrationDao
        //   .generateGoogleAnalyticsTokens(state.brand, route.snapshot.queryParams.code)
        //   .subscribe(res => {
        //     this.notifyOpener('google_analytics', res.id);
        //   });
        break;
      case 'google_ads':
        let s = JSON.parse(route.snapshot.queryParams.state);
        // this.integrationDao.getGoogleAdsTokens(s.brand, route.snapshot.queryParams.code, s.readOnly).subscribe(res => {
        //   this.notifyOpener('google_ads', res.id);
        // });
        break;
      case 'bing':
        if (route.snapshot.queryParams.code) {
          // this.integrationDao
          //   .getBingTokens(route.snapshot.queryParams.state, route.snapshot.queryParams.code)
          //   .subscribe(res => {
          //     this.notifyOpener('bing', res.id);
          //   });
        } else {
          this.notifyOpenerOfError(this.route.snapshot.queryParams);
        }
        break;
      case 'google_drive':
        // this.integrationDao
        //   .createGoogleDrive(route.snapshot.queryParams.code, route.snapshot.queryParams.state)
        //   .subscribe(res => {
        //     setTimeout(() => {
        //       this.notifyOpener('google_drive', res.id);
        //     } , 500);
        //   });
        break;
      case 'google_tag_manager':
        let gtmState = JSON.parse(route.snapshot.queryParams.state);
        // this.integrationDao.getGoogleTagManagerTokens(gtmState.brand, route.snapshot.queryParams.code).subscribe(res => {
        //   this.notifyOpener('google_tag_manager', res.id);
        // });
        break;
    }
  }

  notifyOpener(type, id) {
    this.state = 'connected';

    const data = {
      type: type,
      id: id
    }

    window.opener.postMessage(data, this.apiHelper.getOrigin());
  }

  notifyOpenerOfError(e) {
    window.opener.postMessage(e, this.apiHelper.getOrigin());
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {}
}
